import get from 'lodash/get';
import CryptoJS from 'crypto-js';
import { useEffect } from 'react';
import browserHistory from 'react-router/lib/browserHistory';
import { useSelector } from 'react-redux';
import updateIntercom from '../../utils/updateIntercom';
import { loggedUserSelector } from '../../redux/context/selectors';
import { INTERCOM_SECRET_KEY } from '../../constants/env';

const IntercomIntegration = () => {
  const loggedUser = useSelector(loggedUserSelector);

  const isUserLogged = Object.keys(loggedUser).length > 0;

  const email = get(loggedUser, 'email', '');

  const phoneNumber = get(loggedUser, 'phoneNumber', '');

  const emailReplace = `#${phoneNumber}@phone.com`;

  const emailValue = email || emailReplace;

  const intercomData = {
    email: emailValue,
    user_hash: CryptoJS.HmacSHA256(emailValue, INTERCOM_SECRET_KEY).toString(
      CryptoJS.enc.Hex,
    ),
  };

  useEffect(() => {
    let unlisten = () => {};

    if (isUserLogged) {
      unlisten = browserHistory.listen(() => {
        updateIntercom(intercomData);
      });
    }

    return () => {
      unlisten();
    };
  }, [isUserLogged, intercomData]);

  return null;
};

export default IntercomIntegration;



// WEBPACK FOOTER //
// ./src/components/App/IntercomIntegration.jsx